type Params = {
  /** 未割当に戻す処理の実行中 */
  isResetting: boolean;
  /** 自動配車・シナリオ配車をサーバが受け付けている */
  isAutoDispatching: boolean;
  /** 車両・車番・ドライバーの差し替えがサーバ反映待ち */
  isApplyingVehicleChange: boolean;
  /** 運賃計算の実行中。自動配車と同じく待ち時間があるので同じ場所で知らせる */
  isCalculatingTariff?: boolean;
};

/**
 * 右下の進行中トーストの文言。null なら出さない。
 *
 * 車両の差し替えを含めるのは、以前カードを緑にして知らせていたのをやめたため。
 * 色が変わると「何かおかしくなった」ように見えるので、実行中であることは
 * 自動配車と同じ場所・同じ見た目で伝える。
 *
 * 並びは止められない処理から先に出す（未割当に戻す > 自動配車 > 運賃計算 > 変更反映）。
 * 同時に走ったときに、止める手段のある方の文言で上書きしない。
 */
export function resolveProgressToastLabel({
  isResetting, isAutoDispatching, isApplyingVehicleChange, isCalculatingTariff = false,
}: Params): string | null {
  if (isResetting) return '未割当に戻しています…';
  if (isAutoDispatching) return '自動配車を計算中…';
  if (isCalculatingTariff) return '運賃を計算中…';
  if (isApplyingVehicleChange) return '変更を反映中…';
  return null;
}
